export class QueryParam {
  pageSize: number;
  pageSkip: number;
}
